// extracted by mini-css-extract-plugin
export default {"div":"Interests_div__FV+yw","headline":"Interests_headline__ipQDR"};